import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Switch, Select } from 'antd'
import update from 'react-addons-update';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import moment from 'moment'
import './liveManagement.less'
const { Option } = Select;
let dragingIndex = -1; 
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class LiveManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			visible: false,
			bosObj: null,
			fileType: 'limit',
			scriptStatus: 'no',
			fileList: [],
			token: '',
			autoCompleteResult: [],
			modelTitle: '新增直播',
			qsCodeName: '',
			introduction: '',
			selectValue: undefined,
			name: '',
			subjectIcon: {},
			premiereTime: undefined,
			lowerTime: undefined,
			preset: '',
			liveUrl: '',
			// subjectId: undefined,
			liveId: '',
			searchName: '',
			dataSource: [],
			notChanged: [],
			qiuniuUrl: '',
			optionList: [],
			searchData: {
				total: 0,
				pageNum: 1,
				pageSize: 10
			},
			columns: [
				{
					title: '直播名称',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: '所属学科',
					dataIndex: 'subjectName',
					key: 'subjectName',
					align: 'center'
				},
				{
					title: '开播时间',
					dataIndex: 'premiereTime',
					key: 'premiereTime',
					align: 'center'
				},
				{
					title: '结束时间',
					dataIndex: 'lowerTime',
					key: 'lowerTime',
					align: 'center'
				},
				{
					title: '点击用户数',
					dataIndex: 'num',
					key: 'num',
					align: 'center'
				},
				{
					title: '创建人',
					dataIndex: 'userName',
					key: 'userName',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '发布状态',
					dataIndex: 'state',
					key: 'state',
					align: 'center',
					render: (record, text) => {
						return (
							<div>
								<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
									let id = text.id
									let arr = this.state.dataSource
									for (let i = 0; i < arr.length; i++) {
										if (id === arr[i].id) {
											arr[i].state = checked === true ? 1 : 0
											this.setState({
												dataSource: arr
											})
										}
									}
									return (
										Modal.confirm({
											title: `${checked === true ? '启用直播' : '禁用直播'}`,
											okText: "确定",
											cancelText: "取消",
											content: (
												<div>
													<p>{checked === true ? '发布后此直播将展示在小程序，确定要发布吗？' : '禁用后小程序将不展示此直播，确定要禁用吗？'}</p>
												</div>
											),
											onOk: () => {
												this.isRelease(id, checked, 'ok')
											},
											onCancel: () => {
												this.isRelease(id, checked, 'cancel')
											}
										})
									)
								}} />

							</div>
						)
					}
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							sessionStorage.setItem('liveDetailId', JSON.stringify(record.id))
							this.props.history.push({pathname: '/LiveDeatil'})
							// this.setState({
							// 	visible: true,
							// 	liveId: record.id,
							// 	modelTitle: '编辑直播',
							// 	subjectIcon: {
							// 		type: null,
							// 		uid: null,
							// 		url: record.picUrl,
							// 		name: record.name
							// 	},
							// 	name: record.name,
							// 	premiereTime: moment(record.premiereTime),
							// 	lowerTime: moment(record.lowerTime),
							// 	preset: record.preset,
							// 	liveUrl: record.liveUrl,
							// 	subjectId: record.subjectId,

							// })
						}}>编辑</span>
						<span style={{ color: '#277FFF', cursor: 'pointer', marginRight: '15px' }} onClick={() => {
							this.exportData(record)
						}}>下载</span>
						<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除直播',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>广告删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.dellive(record.id)
								},
							});
						}}>删除</span>
					</div>
				},
			]
		}
	}
	getSubject() {
		axios.post('subjectController/getSubject',{
			pageSize: 100,
			pageNum: 1,
		}).then( res => {
			if(res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					optionList: arr.list
				})
			}
		})
	}
	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			console.log(values)
		});
	}
	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			// console.log(values)
			// console.log(values.premiereTime.format('YYYY-MM-DD HH:mm:ss'),)
			// this.setState({ visible: false })
			if (!err) {
				if(new Date(values.premiereTime).getTime()>=new Date(values.lowerTime).getTime()){
					return message.error('下播时间不能小于开播时间')
				}
				if (this.state.modelTitle === '编辑直播') {
					let pic = values.picUrl.url && values.picUrl.url ? values.picUrl.url : this.state.qiuniuUrl + '/' + values.picUrl.response.key
					axios.post('liveController/updateLive', {
						id: this.state.liveId,
						name: values.name,
						picUrl: pic,
						premiereTime: values.premiereTime.format('YYYY-MM-DD HH:mm:ss'),
						lowerTime: values.lowerTime.format('YYYY-MM-DD HH:mm:ss'),
						preset: values.preset,
						liveUrl: values.liveUrl,
						subjectId: values.subjectId,
					}).then(res => {
						if (res.data.code === '200') {
							this.setState({ visible: false })
							message.success('修改成功')
							this.getLiveList()
						} else {
							message.error(res.data.msg)
						}
					})
				} else if (this.state.modelTitle === '新增直播') {
					axios.post('liveController/addLive', {
						name: values.name,
						picUrl: this.state.qiuniuUrl + '/' + values.picUrl.response.key,
						premiereTime: values.premiereTime.format('YYYY-MM-DD HH:mm:ss'),
						lowerTime: values.lowerTime.format('YYYY-MM-DD HH:mm:ss'),
						preset: values.preset,
						liveUrl: values.liveUrl,
						subjectId: values.subjectId,
					}).then(res => {
						if (res.data.code === '200') {
							this.setState({
								name: ''
							})
							this.setState({ visible: false })
							message.success('新增成功')
							this.getLiveList()
						} else {
							message.error(res.data.msg)
						}
					})
				}

			}
		});
	}
	componentDidMount() {
		this.getLiveList()
		this.getSubject()
	}
	componentWillUnmount() {
		this.setState = ()=>false;
	}
	showModal() {
		// this.props.form.resetFields();
		this.setState({ visible: true, modelTitle: '新增直播', subjectIcon: '', preset: undefined, liveUrl: '',premiereTime: undefined })
	}
	isRelease(id, checked, type) {
		if (type === 'ok') {
			axios.post('liveController/liveState', {
				id: id,
				state: checked === true ? 1 : 0
			}).then(res => {
				if (res.data.code === '200') {
					message.success('操作成功')
					// this.getLiveList()
				} else {
					message.error(res.data.msg)
					this.getLiveList()
				}
			})
		} else if (type === 'cancel') {
			this.getLiveList()
		}
	}
	getUploadUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	async getLiveList() {
		axios.post('liveController/queryLive', {
			...this.state.searchData,
			name: this.state.searchName,
			state: this.state.selectValue
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					dataSource: res.data.data.list,
					notChanged: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize,
						total: res.data.data.total
					}
				})
			}
		})
	}
	dellive(id) {
		axios.get(`liveController/delLive/${id}`).then(res => {
			if (res.data.code === '200') {
				message.success('删除成功')
				this.getLiveList()
			} else {
				message.error(res.data.msg)
				this.getLiveList()
			}
		})
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	downValidateForm = (rule, value, callback) => {
		if(value&&new Date(value).getTime()<=new Date().getTime()){
			callback('下播时间必须大于现在的时间')
		}else{
			callback()
		}
	}
	disabledDate = (current) => {
		return current && current < moment().subtract(1, 'days')
	}
	exportData(item){
		// window.location.href = `http://192.168.40.55:8686/video-wechat-manager/api/userController/export?endTime=${this.state.endTime}&startTime=${this.state.startTime}&autoSyn=${this.state.autoSyn}&isHas=${this.state.isHas}&isTeacher=${this.state.isTeacher}`
		let url = item ? 'liveController/export?id=' + item.id : 'liveController/export'
		axios.get( url, {responseType: 'blob'}).then(res =>{
			const link = document.createElement('a')
			let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.setAttribute('download', item ?  item.name + '.xlsx' : '直播人数统计.xlsx')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		})
	}

	components ={
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => { 
		const { dataSource } = this.state;
		const dragRow = dataSource[dragIndex];
		this.setState(
			update(this.state, {
				dataSource: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.dataSource[i].id })
		}
		axios.post('/liveController/updateSort',oldSort).then(res => {
			if(res.data.code === '200' ){
				this.getLiveList()
				message.success('更新排序成功')
			}else {
				message.error(res.data.msg)
			}
			oldSort = []
		})
	};

	render() {

		const { dataSource, columns,  searchData,  searchName,  } = this.state;
	
			const pagination ={
				showSizeChanger: true,
				total: searchData.total,
				pageSizeOptions: ['10', '20', '30', '40'],
				showTotal:() => `共 ${searchData.total} 条`,
				onShowSizeChange: (current,pageSize) => {
					let searchData = this.state.searchData
					searchData.pageNum = current
					searchData.pageSize = pageSize
					this.getLiveList(searchData)
				},
				onChange: (current) => {
					let searchData = this.state.searchData
					searchData.pageNum = current
					this.getLiveList(searchData)
				},
			}
		return (
			<div className="liveManagement">
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>直播管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={searchName} style={{ width: '260px', height: '40px', marginRight: '20px' }} placeholder="请输入直播名称" onChange={(e) => {
							this.setState({
								searchName: e.target.value
							})
						}}></Input>
						<Select  placeholder="发布状态" value={this.state.selectValue} allowClear style={{ width: 140, height: '20px', marginRight: '20px' }} onChange={(value)=>{
							this.setState({
								selectValue: value
							})
						}}>
							<Option value="0">未发布</Option>
							<Option value="1">已发布</Option>
						</Select>
						<Button className='my-button-primary' style={{ marginRight: '20px' }} onClick={() => {
							this.getLiveList()
						}} type='primary'>搜索</Button>
						<span className='my-button-txt' onClick={() => {
							this.setState({ name: '',selectValue: undefined }, () => {
								this.getLiveList()
							})
						}} >重置</span>
					</div>
					<div>
						<Button className='my-button-primary' style={{ marginRight: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.exportData()	
							}}>导出</Button>
						<Button className='my-button-primary' type='primary' onClick={() => { 
							sessionStorage.setItem('liveDetailId', '')
							this.props.history.push({pathname: '/LiveDeatil'})
						 }}>新增直播</Button>
					</div>
					
					
				</div>
				<DndProvider backend={HTML5Backend}>
				   <Table pagination={pagination} 
						components={this.components}
						dataSource={dataSource} columns={columns} 
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')} 
						rowKey={record => record.id} 
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}
					/>
				</DndProvider>
				{/* <Modal
					getContainer={false}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					maskClosable={false}
					destroyOnClose
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false, name: '' }) }}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk} autoComplete={"off"}>
						<FormItem label={"直播名称"}>
							{getFieldDecorator('name', {
								initialValue: modelTitle === '编辑直播' ? name : '',
								rules: [{ required: true, message: '请输入直播名称!' }, { max: 20, message: '最多输入20个字符' }],
							})(
								<Input placeholder='请输入直播名称' />
							)}
						</FormItem>
						<Form.Item label="封面图">
							{getFieldDecorator('picUrl', {
								initialValue: modelTitle === '编辑直播' ? subjectIcon : '',

								rules: [{type: 'object', required: true, message: '请上传封面!' }],
							})(
								<UploadQiniu getQiniuUrl={this.getQiniuUrl} />
							)}
						</Form.Item>
						<Form.Item label="开播时间">
							{getFieldDecorator('premiereTime',
							 config,
							 {
								rules: [{required: true, message: '请选择开播时间!' }],
							})(
								<DatePicker showTime format="YYYY-MM-DD HH:mm:ss" />,
							)}
						</Form.Item>
						<Form.Item label="下播时间">
							{getFieldDecorator('lowerTime',
							 {
								rules: [
									{required: true, message: '请选择下播时间' },
									{ validator: this.downValidateForm }
								],
								initialValue: modelTitle === '编辑直播' ? lowerTime : undefined,
							})(
								<DatePicker showTime disabledDate={this.disabledDate} format="YYYY-MM-DD HH:mm:ss" />,
							)}
						</Form.Item>
						<FormItem label={"预设人数"}>
							{getFieldDecorator('preset', {
								initialValue: modelTitle === '编辑直播' ? preset : '',
								
							})(
								<InputNumber placeholder='请输入预设人数' precision={0}/>
							)}
						</FormItem>
						<FormItem label={"直播链接"}>
							{getFieldDecorator('liveUrl', {
								initialValue: modelTitle === '编辑直播' ? liveUrl : ''
							})(
								<TextArea style={{ width: '100%' }} placeholder='请输入直播链接' />
							)}
						</FormItem>
						<Form.Item label="所属学科">
							{getFieldDecorator('subjectId', {
								initialValue:modelTitle==='编辑直播'? subjectId: undefined
							})(
								<Select
								placeholder="请选择学科"
								>
									{this.state.optionList.map(item=>{
										return (<Option key={item.id} value={item.id}>{item.name}</Option>)
									})}
								</Select>
							)}
						</Form.Item>
					</Form>
				</Modal> */}
			</div>
		)
	}
}

export default Form.create()(LiveManagement)